<template>
<div class="container">
<b-row v-if="!isLoading">
	<h5>
	<label for="desde">Desde</label> &nbsp;
	<input type="date" name="" id="desde" v-model="desde" @click="desde='';hasta='';pais='';paises=false;muestreLista=false">&nbsp; 
	<label for="hasta">Hasta</label> &nbsp;
	<input type="date" name="" id="hasta" v-model="hasta" @click="hasta='';pais='';paises=false" @input="f_seleccione_pais()">&nbsp; 
	<label v-if="paises">País</label>
	<select v-if="paises" v-model="pais" @click="f_restaure_botones()">
		<option
			v-for="(item, idx) in listPaises"
				:key="idx"
				:value="item.pais">
				{{item.pais}}
			</option>
	</select>
	<span v-if="pais && paises">
		<label v-if="desde && hasta" >Seleccion por:</label> &nbsp;
		<label v-if="desde && hasta" for="Fecha">Fecha</label> &nbsp;
		<input v-if="desde && hasta" type="checkbox" id="Fecha" value="Fecha" v-on:click="uncheck(1)" > &nbsp; &nbsp;
		<label v-if="desde && hasta" for="Proveedor">Proveedor</label> &nbsp;
		<input v-if="desde && hasta" type="checkbox" id="Proveedor" value="Proveedor" v-on:click="uncheck(2)"> &nbsp;&nbsp;		
		<label v-if="desde && hasta" for="Contable">Contable</label> &nbsp;
		<input v-if="desde && hasta" type="checkbox" id="Contable" value="Contable" v-on:click="uncheck(3)"> &nbsp;&nbsp;
	</span>
	</h5>
	<b-container v-if="(Fecha||Proveedor||Contable) && muestreLista==false && desde && hasta">
		<md-table>
			<md-table-cell>
				<md-button class="md-primary md-raised" @click="f_consultar()"><h3>Consultar</h3></md-button>
			</md-table-cell>
			<md-table-cell v-if="fgl_excel">
			<md-button @click="f_listar()" class = "md-fab md-primary "><md-icon><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M21.17 3.25Q21.5 3.25 21.76 3.5 22 3.74 22 4.08V19.92Q22 20.26 21.76 20.5 21.5 20.75 21.17 20.75H7.83Q7.5 20.75 7.24 20.5 7 20.26 7 19.92V17H2.83Q2.5 17 2.24 16.76 2 16.5 2 16.17V7.83Q2 7.5 2.24 7.24 2.5 7 2.83 7H7V4.08Q7 3.74 7.24 3.5 7.5 3.25 7.83 3.25M7 13.06L8.18 15.28H9.97L8 12.06L9.93 8.89H8.22L7.13 10.9L7.09 10.96L7.06 11.03Q6.8 10.5 6.5 9.96 6.25 9.43 5.97 8.89H4.16L6.05 12.08L4 15.28H5.78M13.88 19.5V17H8.25V19.5M13.88 15.75V12.63H12V15.75M13.88 11.38V8.25H12V11.38M13.88 7V4.5H8.25V7M20.75 19.5V17H15.13V19.5M20.75 15.75V12.63H15.13V15.75M20.75 11.38V8.25H15.13V11.38M20.75 7V4.5H15.13V7Z" /></svg>
</md-icon></md-button>
			</md-table-cell>
		</md-table>
		</b-container>
		<b-container v-if="muestreLista">
		<md-table v-model="listFacturas" md-card md-fixed-header @md-selected="f_muestra_facturas">
		<md-table-toolbar>
			<h1 class="md-title"><b><i>{{f_titulo()}}</i></b></h1>
		</md-table-toolbar>
		<md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single">
			<md-table-cell v-if="Fecha" :md-label="labels.fecha" class="text-left border">{{item.fecha_factura}}</md-table-cell>
			<md-table-cell v-if="Proveedor" :md-label="labels.proveedor" class="text-left border">{{item.identificacion}}</md-table-cell>
			<md-table-cell v-if="Proveedor" :md-label="labels.lider_nombre" class="text-left border">{{item.nombre}}</md-table-cell>
			<md-table-cell v-if="Contable" :md-label="labels.documento_contable" class="text-left border">{{item.documento_contable}}</md-table-cell>
			<md-table-cell :md-label="labels.cantidad" class="text-left border">{{item.cantidad}}</md-table-cell>
		</md-table-row>
		<md-table-row v-if="fgl_mensaje">
			<md-table-cell class="col-sm text-center border"><h3><b><i>Reporte en Progreso...............</i></b></h3></md-table-cell>
		</md-table-row>
		</md-table>
		</b-container>
		<md-dialog :md-active.sync="muestreFacturas">
		<md-dialog-title class="text-center">
			<h3><b><i>{{titulo_estado}}</i></b></h3>
		</md-dialog-title>
		<md-dialog-content>
			<md-table v-model="listFacturasCliente" md-card md-fixed-header @md-selected="f_muestra_detalle">
				<md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single">
					<md-table-cell :md-label="labels.fecha" class="text-left border">{{item.fecha_factura}}</md-table-cell>
					<md-table-cell :md-label="labels.factura" class="text-left border">{{item.factura}}</md-table-cell>
					<md-table-cell :md-label="labels.identificacion" class="text-left border">{{item.identificacion}}</md-table-cell>
					<md-table-cell :md-label="labels.proveedor" class="text-left border">{{item.nombre}}</md-table-cell>
					<md-table-cell :md-label="labels.valor_total" class="text-right border">{{item.valor_total}}</md-table-cell>
					<md-table-cell :md-label="labels.documento_contable" class="text-right border">{{item.documento_contable}}</md-table-cell>
					<md-table-cell :md-label="labels.estado" class="text-right border">{{f_estado(item.estado)}}</md-table-cell>
				</md-table-row>
			</md-table>
			<md-dialog-actions>
				<md-button class="md-accent" @click="muestreFacturas = false">Cerrar</md-button>
			</md-dialog-actions>
		</md-dialog-content>
		</md-dialog>
		<md-dialog :md-active.sync="muestreDetalleFacturas">
		<md-dialog-content>
			<md-dialog-title class="text-center">
				<h3><b><i>{{titulo_factura}}</i></b></h3>
				</md-dialog-title>
			<md-table >
				<md-table-row >
					<md-table-cell class="text-right border"><b><i>Factura {{factura.factura}} - {{factura.fecha_factura}}</i></b></md-table-cell>
					<md-table-cell class="text-left border"><b><i>{{factura.identificacion}} - {{factura.nombre}}</i></b></md-table-cell>
					<md-table-cell class="text-left border">Pedido/Remision {{factura.pedido}}/{{factura.remision}}</md-table-cell>
				</md-table-row>
				<md-table-row >
					<md-table-cell class="text-right border"><b><i>Valor Bruto {{factura.valor}}</i></b></md-table-cell>
					<md-table-cell class="text-left border"><b><i>Impuestos {{factura.impuesto_total}}</i></b></md-table-cell>
					<md-table-cell class="text-left border"><b><i>Total {{factura.valor_total}}</i></b></md-table-cell>
				</md-table-row>
				<md-table-row>
					<md-table-cell class="text-right border"><b><i>Lider:</i></b>{{f_usuario_nombre(factura.id_lider)}} <b><i>Analista:</i></b>{{f_usuario_nombre(factura.id_usuario)}}</md-table-cell>
					<md-table-cell class="text-left border"><b><i>Documento Contable {{factura.documento_contable}}</i></b></md-table-cell>
					<md-table-cell class="text-left border"><b><i>Estado {{f_estado(factura.estado)}} </i></b></md-table-cell>
				</md-table-row>
				<md-table-row>
					<md-table-cell class="text-center border" colspan="3"><h3><b><i>Anulacion</i></b></h3></md-table-cell>
				</md-table-row>
				<md-table-row v-if="opcion==2">
					<md-table-cell class="text-right border">
					<h5>Fecha Solicitud &nbsp;&nbsp; {{anulacion.fecha_solicitud}} </h5>
					</md-table-cell>
					<md-table-cell class="text-right border">
					<h5>Numero Contable &nbsp;&nbsp; {{anulacion.numero_contable_anula}}</h5>
					</md-table-cell>
					<md-table-cell class="text-left border">
						<h5>Motivo &nbsp;&nbsp; {{anulacion.motivo}}</h5>
					</md-table-cell>
				</md-table-row>
				<md-table-row v-if="opcion==1">
					<md-table-cell class="text-right border">
					<md-field><h4><b><i>Fecha Solicitud </i></b></h4>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <md-input type="date" name="" id="fecha_solicitud" v-model="anulacion.fecha_solicitud"></md-input></md-field>
					</md-table-cell>
					<md-table-cell class="text-right border" >
						<md-field>Numero Contable&nbsp;&nbsp; <md-input v-model="anulacion.numero_contable_anula" ></md-input></md-field>
					</md-table-cell>
					<md-table-cell class="text-left border">
						<md-field>Motivo &nbsp;&nbsp; <md-input v-model="anulacion.motivo" ></md-input></md-field>
					</md-table-cell>
				</md-table-row>
				<md-table-row v-if="opcion==2">
					<md-table-cell class="text-right border">
					<md-field><h4><b><i>Fecha Anulacion </i></b></h4>&nbsp;&nbsp;&nbsp; <md-input type="date" name="" id="fecha_anulacion" v-model="anulacion.fecha_anulacion"></md-input></md-field>
					</md-table-cell>
					<md-table-cell class="text-left border" >
						<md-field>Documento Anulación &nbsp;&nbsp;<md-input v-model="anulacion.documento_anulacion"></md-input></md-field>
					</md-table-cell>
					<md-table-cell class="text-left border" >
						<md-field>Documento Compensación&nbsp;&nbsp;<md-input v-model="anulacion.documento_compensacion"></md-input></md-field>
					</md-table-cell>
				</md-table-row>
				<md-table-row v-if="opcion==2">
					<md-table-cell class="text-right border">
					<md-field>
					<h4><b><i>Estado</i></b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;
					<select v-model="anulacion.estado">
					<option value="Anulado">Anulado</option>
					<option value="Rechazado">Rechazado</option>
					</select></h4>
					</md-field>
					</md-table-cell>
					<md-table-cell class="text-left border" colspan="2">
						<md-field><md-input v-model="anulacion.comentario" placeholder="Comentario"></md-input></md-field>
					</md-table-cell>
				</md-table-row>
			</md-table>
			<md-dialog-actions>
				<md-button class="md-primary" @click="f_grabe_anulacion()">Grabar</md-button>
				<md-button class="md-accent" @click="muestreDetalleFacturas=false">Cerrar</md-button>
			</md-dialog-actions>
		</md-dialog-content>
		</md-dialog>
		</b-row>
	</div>
</template>
<script>
import Seguimiento from "@/services/Seguimiento"
import User from "@/services/User"
import Estado from "@/services/Estados"
import * as XLSX from "exceljs"

export default {
name:'Seguimiento',
data: () => ({
	isLoading: false,
	Fecha : false,
	Proveedor : false,
	Contable : false,
	Factura : false,
	desde: '',
	hasta: '',
	opcion: 0,
	operacion: '',
	factura: '',
	anulacion: '',
	pais: '',
	paises: false,
	titulo_factura: "",
	titulo_estado: "",
	users : [],
	listEstados : [],
	listPaises : [],
	listFacturas : [],
	listFacturasCliente : [],
	listAnulacion : [],
	muestreLista: false,
	muestreListado: false,
	muestreFacturas: false,
	muestreDetalleFacturas: false,
	observaciones: '',
	fgl_anula: false,
	fgl_excel: true,
	fgl_mensaje: false,
}),
computed:{
labels(){
	if (this.$store.state._language == "es-ES") {
		return {
			title : "FACTURAS",
			factura : "Número Factura",
			fecha : "Fecha Factura",
			identificacion : "Número Identificación",
			proveedor : "Nombre del Proveedor",
			cantidad : "Facturas",
			pedido : "Número Pedido",
			valor : "Valor Bruto",
			impuesto0 : "Impuesto0",
			categoria0 : "Categoria0",
			impuesto1 : "Impuesto1",
			categoria1 : "Categoria1",
			impuesto2 : "Impuesto2",
			categoria2 : "Categoria2",
			impuesto : "Total Impuesto",
			valor_total : "Total Factura",
			items : "Items",
			estado: "Estado",
			lider: "Lider",
			lider_nombre:   "Nombre del Lider",
			usuario: "Usuario",
			usuario_nombre: "Nombre del Usuario",
			documento_contable: "Documento Contable",
		}
	}else{
		return {
			title : "INVOICES",
			factura : "Invoice",
			fecha : "Date",
			identificacion : "Identification",
			proveedor : "Name",
			cantidad : "Invoices",
			pedido : "Order",
			valor : "Amount",
			impuesto0 : "Tax0",
			categoria0 : "Category0",
			impuesto1 : "Tax1",
			categoria1 : "Category1",
			impuesto2 : "Tax2",
			categoria2 : "Category2",
			impuesto : "Taxes",
			valor_total : "Total Amount",
			items : "Items",
			estado: "Condition",
			lider: "Leader",
			lider_nombre: "Leader Name",
			usuario: "User",
			usuario_nombre: "User Name",
		}
	}
}
},
mounted(){
	if	(this.$route.name == "Sreganula") {
		this.opcion=1
	} else {
		this.opcion=2
	}
	User.getAllUsers(this.$store.state.userName)
	.then((result) => {
		this.users = result.data.users;
	})
	.catch((err) => {
		console.log(err)
	})
	Estado.leaEstados(false)
	.then((result) => {
		this.listEstados = result.data.listEstados;
	})
	.catch((err) => {
		console.log(err)
	})
	},
methods:{
	f_titulo() {
		if	(this.$route.name == "Sreganula") {
			this.fgl_excel=false
			this.fgl_anula=0
			return "REGISTRO ANULACION DE CONTABILIZACION"
		}
		if	(this.$route.name == "Sanulaciones") {
			this.fgl_anula=1
			return "ANULACION DE CONTABILIZACION"
		}
		return this.$route.name
	},
	f_muestra_facturas(r_facturas) {
		this.muestreFacturas=false
		if	(this.Fecha) {
			this.titulo_estado = "Fecha : " + r_facturas.fecha_factura+" - "+this.pais
		}
		if	(this.Proveedor) {
			this.titulo_estado = "Proveedor : " + r_facturas.nombre+" - "+this.pais
		}
		if	(this.Contable) {
			this.titulo_estado = "Documento Contable : " + r_facturas.documento_contable+" - "+this.pais
		}
		Seguimiento.leaFacturasAnulacion(
			this.fgl_anula,
			this.operacion,this.pais,
			this.desde,this.hasta,
			r_facturas.fecha_factura,
			r_facturas.identificacion,
			r_facturas.documento_contable)
		.then((res) => {
			this.listFacturasCliente = res.data.listFacturasCliente
			this.muestreFacturas=true
		})
		.catch((err) => {
			console.log(err)
		})
	},
	f_muestra_detalle(r_factura) {
		this.factura=r_factura
		this.anulacion={}
		this.anulacion.fecha_solicitud=''
		this.anulacion.numero_contable_anula=''
		this.anulacion.motivo=''
		this.anulacion.fecha_anulacion=''
		this.anulacion.documento_anulacion=''
		this.anulacion.documento_compensacion=''
		this.anulacion.estado=''
		this.anulacion.comentario=''
		this.titulo_factura = "Anulacion Documento "+r_factura.factura+" "+r_factura.nombre
		if	(this.$route.name == "Sanulaciones") {
			Seguimiento.leaAnulacionRegistrada(
				this.pais,
				r_factura.factura,
				r_factura.identificacion)
			.then((res) => {
				this.listAnulacion = res.data.listAnulacion
			})
		} else {
			this.listAnulacion=[]
		}
		setTimeout(() => {
			if	(this.listAnulacion.length > 0) {
				this.muestreDetalleFacturas=true
				this.anulacion.id_anulacion=this.listAnulacion[0].id
				this.anulacion.fecha_solicitud=this.listAnulacion[0].fecha_solicitud
				this.anulacion.numero_contable_anula=this.listAnulacion[0].numero_contable_anula
				this.anulacion.motivo=this.listAnulacion[0].motivo_anulacion
				this.muestreDetalleFacturas=true
			} else {
				if	(this.$route.name == "Sanulaciones") {
					this.$toast.error("No existe Anulacion registrada para "+r_factura.factura)
				} else {
					this.muestreDetalleFacturas=true
				}
			}
		},500)
	},
	uncheck(opcion) {
		this.operacion = ''
		var checkbox1 = document.getElementById("Fecha");
		var checkbox2 = document.getElementById("Proveedor");
		var checkbox3 = document.getElementById("Contable");
		checkbox1.checked=false;
		checkbox2.checked=false;
		checkbox3.checked=false;
		this.Fecha=false;
		this.Proveedor=false;
		this.Contable=false;
		if (opcion == 1) {
			checkbox1.checked=true;
			this.Fecha=true;
			this.operacion="fecha"
		}
		if (opcion == 2) {
			checkbox2.checked=true;
			this.Proveedor=true;
			this.operacion="proveedor"
		}
		if (opcion == 3) {
			checkbox3.checked=true;
			this.Contable=true;
			this.operacion="contable"
		}
		this.muestreLista=false
	},
	f_consultar() {
		Seguimiento.anuleFacturas(this.fgl_anula,this.operacion,this.pais,this.desde,this.hasta)
		.then((res) => {
			this.listFacturas = res.data.listFacturas
			if	(this.listFacturas.length > 0) {
				this.muestreLista = true
			} else {
				this.f_restaure_botones()
			}
		})
		.catch((err) => {
			console.log(err)
		})
	},
	f_listar() {
		this.fgl_mensaje = true
		Seguimiento.listeFacturasAnuladas(this.pais,this.desde,this.hasta)
		.then((res) => {
			this.listFacturas = res.data.listFacturas
		})
		.then(() => {
			this.descargueInformacion()
			this.fgl_mensaje=false
		})
		.catch((err) => {
			console.log(err)
		})

	
	},
	async descargueInformacion() {
		let createdAt1 = new Date()
		let anio = createdAt1.getFullYear()
		let mes = createdAt1.getMonth()+1
		let dia = createdAt1.getDate()
		let createdAt = anio+"-"+mes+"-"+dia

		let titulo = "ANULACIONES "+this.pais+
			" INFORMACION DESDE "+this.desde+
			" HASTA "+this.hasta
		let userName = this.$store.state.userName

		const {Workbook} = XLSX
		const workbook = new Workbook()
		const worksheet = workbook.addWorksheet("Registro")

		const ENCABEZADO1 = [
			titulo
		]
		worksheet.addRow(ENCABEZADO1)
		const ENCABEZADO3 = [
			"Creado "+createdAt+" por "+userName,
		]
		worksheet.addRow(ENCABEZADO3)
		const ENCABEZADO5 = [
		]
		worksheet.addRow(ENCABEZADO5)
		
		const HEADER_ROW = [
			"Fecha Solicitud",
			"Factura",
			"Identificacion",
			"Nombre",
			"Fecha Factura",
			"Documento Contable",
			"Numero Contable Anulacion",
			"Motivo Anulacion",
			"Fecha Anulacion",
			"Documento Anulacion",
			"Documento Compensacion",
			"Estado",
			"BPO",
			"Comentario",
		]
		worksheet.addRow(HEADER_ROW)
		
		this.listFacturas.forEach((anulacion) => {
			let fecha_anulacion=''
			if	(anulacion.fecha_anulacion != null) {
				fecha_anulacion = anulacion.fecha_anulacion.toString()
				fecha_anulacion=fecha_anulacion.substr(0,10)
			}
			const v_fila = [
				anulacion.fecha_solicitud,
				anulacion.factura,
				anulacion.identificacion,
				anulacion.nombre,
				anulacion.fecha_factura,
				anulacion.documento_contable,
				anulacion.numero_contable_anula,
				anulacion.motivo_anulacion,
				fecha_anulacion,
				anulacion.documento_anulacion,
				anulacion.documento_compensacion,
				anulacion.estado,
				anulacion.bpo,
				anulacion.comentario,
			]
			worksheet.addRow(v_fila)
		})

		const file = await workbook.xlsx.writeBuffer()
		const downloadLink = document.createElement("a")
		downloadLink.download = "ANULACIONES "+this.desde+"-"+this.hasta+".xlsx"
		downloadLink.href = window.URL.createObjectURL(
			new Blob([file], {
			type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
			})
		)

		downloadLink.style.display = "none";

		document.body.appendChild(downloadLink);
		downloadLink.click();

		downloadLink.remove();
		
	},
	f_estado(estado) {
		if	(estado == null) {
			return "Por asignar"
		}
		const v_estado = this.listEstados.find((r_estado) => r_estado.estado==estado)
		return v_estado.descripcion
	},
	f_seleccione_facturas() {
		this.muestreDetalleFacturas=false
		this.muestreFacturas=false
		this.muestreLista=true
	},
	f_seleccione_pais() {
		this.listPaises = []
		this.paises=true
		if	(this.desde && this.hasta) {
			Seguimiento.leaPaises(2,this.desde,this.hasta)
			.then((res) => {
				this.listPaises = res.data.listPaises
				this.pais=''
				if	(this.listPaises.lenght>0) {
					this.paises=true
				}
			})
			.catch((err) => {
				console.log(err)
			})
		}
	},
	f_restaure_botones() {
		this.Fecha=false
		this.Lider=false
		this.Contable=false
		this.Fecha=false
		var checkbox1 = document.getElementById("Fecha")
		var checkbox2 = document.getElementById("Proveedor")
		var checkbox3 = document.getElementById("Contable")
		checkbox1.checked=false
		checkbox2.checked=false
		checkbox3.checked=false
		this.muestreLista=false
	},
	f_usuario_nombre(p_id) {
		if	(p_id === null || p_id == undefined) {
			return ""
		}
		const v_usuario=this.users.find((r_usuario) => r_usuario.id==p_id)
		return v_usuario.name
	},
	f_grabe_anulacion() {
		let informacion = this.anulacion
		informacion.id=this.factura.id
		informacion.pais=this.pais
		informacion.documento=this.factura.documento
		informacion.factura=this.factura.factura
		informacion.fecha_factura=this.factura.fecha_factura
		informacion.documento_contable=this.factura.documento_contable
		informacion.archivo = this.factura.archivo
		informacion.estado_anterior = this.factura.estado
		informacion.fecha_estado_anterior = this.factura.updatedAt
		informacion.id_lider = this.factura.id_lider
		informacion.id_usuario = this.factura.id_usuario
		informacion.identificacion = this.factura.identificacion
		informacion.nombre = this.factura.nombre
		informacion.u_crea = this.$store.state.userId
		if	(this.$route.name == "Sreganula") {
			informacion.operacion="registro"
		} else {
			informacion.operacion="anulacion"
		}
		Seguimiento.grabeAnulacion(informacion)
		.then(() => {
			this.$toast.success("Registro de Anulacion OK")
		})
		.catch(() => {
			this.$toast.error("Problema al Registrar Anulacion")
		})
		this.muestreDetalleFacturas=false
		this.f_muestra_facturas()
		if	(this.listFacturasCliente.length==0) {
			this.f_consultar()
		}
	}
}

}
</script>

<style>
table {
	table-layout:fixed;
}
.md-table-fixed-header-active {
	border-bottom: 20px solid;
}

</style>
